module.exports = __webpack_public_path__ + "img/logo_swisstph.47ea9938.svg";